import { render, staticRenderFns } from "./ProjectInitiationForm.vue?vue&type=template&id=5fdec785&"
import script from "./ProjectInitiationForm.vue?vue&type=script&lang=js&"
export * from "./ProjectInitiationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports